import LocalizedStrings from "react-localization";
import {resource_strings} from "../translations/resource_translations";
import localeHelpers from "./LocaleHelper";

const categoryHelpers = {
    categories: function () {
        let resourceStrings = new LocalizedStrings(resource_strings);
        resourceStrings.setLanguage(localeHelpers.currentLocale());

        return [
            {value: 'food', label: resourceStrings.categories.food, icon: require("assets/img/icons/common/food.svg").default},
            {
                value: 'drinks',
                label: resourceStrings.categories.drinks,
                icon: require("assets/img/icons/common/drinks.svg")
            },
            {
                value: 'equip',
                label: resourceStrings.categories.equip,
                icon: require("assets/img/icons/common/yoga-mat.svg")
            },
            {value: 'rent', label: resourceStrings.categories.rent, icon: require("assets/img/icons/common/rent.svg").default},
            {
                value: 'service',
                label: resourceStrings.categories.service,
                icon: require("assets/img/icons/common/services.svg")
            },
            {
                value: 'clothes',
                label: resourceStrings.categories.clothes,
                icon: require("assets/img/icons/common/clothes.svg")
            },
            {
                value: 'books',
                label: resourceStrings.categories.books,
                icon: require("assets/img/icons/common/book.svg")
            },
            {
                value: 'gifts',
                label: resourceStrings.categories.gifts,
                icon: require("assets/img/icons/common/gift.svg")
            },
            {
                value: 'meds',
                label: resourceStrings.categories.meds,
                icon: require("assets/img/icons/common/bandage.svg")
            },
            {
                value: 'transport',
                label: resourceStrings.categories.transport,
                icon: require("assets/img/icons/common/transport.svg")
            },
            {
                value: 'other',
                label: resourceStrings.categories.other,
                icon: require("assets/img/icons/common/question_white.svg")
            },{
                value: 'teaching',
                label: resourceStrings.categories.teaching,
                icon: require("assets/img/icons/common/teaching.svg")
            },{
                value: 'taxes',
                label: resourceStrings.categories.taxes,
                icon: require("assets/img/icons/common/taxes.svg")
            },{
                value: 'salaries',
                label: resourceStrings.categories.salaries,
                icon: require("assets/img/icons/common/salary.svg")
            },{
                value: 'sales',
                label: resourceStrings.categories.sales,
                icon: require("assets/img/icons/common/sales.svg")
            },{
                value: 'marketing',
                label: resourceStrings.categories.marketing,
                icon: require("assets/img/icons/common/marketing.svg")
            },{
                value: 'supplies',
                label: resourceStrings.categories.supplies,
                icon: require("assets/img/icons/common/supplies.svg")
            },
        ];
    },

    notDefined: function() {
        return this.categories()[0]
    }
};

export default categoryHelpers;